/* ==========================================================================
   LoadingInformation > Client > Config
   ========================================================================== */

/* Config */
const config = {
    component: 'LoadingInformation',
    init: true,
    autoStore: true,
    css: {
        body: 'loading-information__body',
        title: 'loading-information__title',
        description: 'loading-information__description',
        message: 'loading-information__message'
    },
    image: {
        src: '',
        resize: {
            height: 220,
            width: 450
        }
    }
};

module.exports = () => config;
